<template>
    <div class="flow_box safe-distance-top-header">
        <Header :pageTitle="pageTitle" />
        <div class="flow_info">
            <div class="flow_title">
                <span class="flow_name">收货人：{{ userInfo.consignee }}</span>
                <span class="flow_tel">{{ userInfo.phone }}</span>
            </div>
            <p class="flow_address">{{ userInfo.provinceName }} {{ userInfo.cityName }} {{ userInfo.districtName }}
                {{ userInfo.streetName }} {{ userInfo.detailAddress }}</p>
        </div>
        <div class="expressage_box">
            <div class="expressage_title">
                <span class="expressage_name">{{ expressDetail.companyName }} {{ expressDetail.expressRecord.number
                }}</span>
                <span @click="toCopy(expressDetail.expressRecord.number)">复制</span>
            </div>
            <van-steps v-if="expressList && expressList.length" active-color="#FF3D3D" direction="vertical" :active="0">
                <van-step v-for="(item, index) in expressList" :key="index">
                    <div class="express_list_title">
                        <span :class="['express_list_status', index === 0 ? 'first_status' : '']">{{ item.status }}</span>
                        <span class="express_list_time">{{ item.time }}</span>
                    </div>
                    <p class="express_list_content" v-html="highLightMobile(item.context)"></p>
                </van-step>
            </van-steps>
            <div v-else class="none_box">
                <img src="@/assets/img/mobileImg/searchNone.png" alt="" />
                <div>暂无物流信息</div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/views/mobileView/components/header/index.vue";
export default {
    name: 'MaterialFlow',
    components: {
        Header
    },
    data() {
        return {
            pageTitle: '',
            userInfo: {},
            expressDetail: {},
            expressList: [],
        }
    },
    created() {
        this.pageTitle = this.$route.query.key == 1 ? '退货详情' : '换货详情'
        this.getDetail()
    },
    methods: {
        async getDetail() {
            let res = await this.$apis.afterSalesOrder.detailOrder({ id: this.$route.query.id });
            if (res.resultCode === '200') {
                if (this.$route.query.key == 1) {
                    this.userInfo = res.data.sellerReceipt ? res.data.sellerReceipt : {}
                } else {
                    this.userInfo = res.data.buyerDelivery ? res.data.buyerDelivery : {}
                }
                this.expressDetail = res.data.afterSaleExpressDtoList.filter(item => item.expressType == this.$route.query.key)[0].dto
                this.expressList = this.expressDetail.expressRecord.callbackJson.lastResult.data
            }
        },
        toCopy(number) {
            const input = document.createElement("input");
            input.setAttribute("readonly", "readonly");
            input.setAttribute("value", number);
            document.body.appendChild(input);
            input.select();
            if (document.execCommand("copy")) {
                document.execCommand("copy");
                this.$toast("复制成功");
            }
            document.body.removeChild(input);
        },
        // 电话号码高亮显示
        highLightMobile(str) {
            let regx = /(\d{11}|\d{3}-\d{8}|\d{4}-\d{8})/g;
            let phoneNums = str.match(regx);
            if (phoneNums != null && phoneNums.length) {
                phoneNums = Array.from(new Set(phoneNums));
            }
            if (phoneNums) {
                for (var i = 0; i < phoneNums.length; i++) {
                    var temp = phoneNums[i];
                    str = str.replace(
                        new RegExp(phoneNums[i], "g"),
                        `<a href="tel:${temp}" style="color: #397bf9;">${temp}</a>`
                    );
                }
            }
            return str;
        },
    }
}

</script>

<style lang='scss' scoped>
.flow_box {
    padding: 12px;
    min-height: 100vh;
    background-color: #f5f5f5;

    .flow_info {
        margin-bottom: 12px;
        padding: 15px 12px;
        width: 100%;
        background-color: #fff;
        border-radius: 8px;

        .flow_title {
            margin-bottom: 8px;

            .flow_name {
                font-size: 14px;
                color: #333333;
                font-weight: 700;
                line-height: 20px;
            }

            .flow_tel {
                margin-left: 16px;
                font-size: 12px;
                color: #999999;
                line-height: 17px;
            }
        }

        .flow_address {
            font-size: 13px;
            color: #999999;
            line-height: 20px;
        }
    }

    .expressage_box {
        padding: 15px 12px;
        width: 100%;
        background-color: #fff;
        border-radius: 8px;

        .expressage_title {
            margin-bottom: 11px;
            display: flex;
            justify-content: space-between;
            color: #333;
            font-size: 13px;

            .expressage_name {
                font-weight: 700;
            }
        }

        .express_list_title {
            margin-bottom: 6px;

            .express_list_status {
                font-weight: 700;
                font-size: 15px;
                color: #333;
                line-height: 21px;
            }

            .first_status {
                color: #FF3D3D;
            }

            .express_list_time {
                margin-left: 13px;
                font-size: 13px;
                color: #999999;
                line-height: 19px;
            }
        }

        .express_list_content {
            font-size: 13px;
            color: #666666;
            line-height: 20px;
        }
        .none_box {
            text-align: center;
            img {
                margin-top: 20px;
                margin-bottom: 20px;
                width: 200px;
                height: 200px;
            }

        }
    }
}
</style>